import { render } from "./RegistrationPage.vue?vue&type=template&id=27f4db94&scoped=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=js"
export * from "./RegistrationPage.vue?vue&type=script&lang=js"

import "./RegistrationPage.vue?vue&type=style&index=0&id=27f4db94&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27f4db94"]])

export default __exports__